const eAnimation = {
  animation: [
  ],
};

export default eAnimation;
